import { call, select } from 'redux-saga/effects'
import { IPcr } from '../../pcr/store/pcr.types'
import { getAuthenticationJwtSelector } from '../../login/selectors/getAuthenticationJwt.selector'
import { getServiceIdSelector } from '../../user/selectors'
import { SubmitChartService } from '../../submitChart/services/submitChart.service'
import { IFetchPRIDResponse } from '../../submitChart/store/submitChart.types'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { isOnline } from '../../../utilities/isOnline.util'
import Logger from '../../../services/logger.service'
import { initialSubmitChartState } from '../../submitChart/store/submitChart.reducers'

export function* ensurePridFetched(pcrDoc: IPcr): Generator<any, string | null, any> {
  if (pcrDoc.prid || !isOnline()) return null

  try {
    const authJwt: string = yield select(getAuthenticationJwtSelector)
    const serviceId: string = yield select(getServiceIdSelector)
    const submitChartService = new SubmitChartService(authJwt)
    const pridResponse: IFetchPRIDResponse = yield call([submitChartService, submitChartService.fetchPRID])

    if (pridResponse?.status === 200 && pridResponse.data?.prid) {
      const prid = pridResponse.data.prid.toString()
      const pcrDocsService = new PcrDocsService(serviceId)
      yield call([pcrDocsService, pcrDocsService.savePCRSilent], {
        ...pcrDoc,
        prid,
        submitChart: { ...(pcrDoc.submitChart ?? initialSubmitChartState), prid },
      })
      Logger.info(`ensurePridFetched: PRID saved for pcrId=${pcrDoc.pcrId} → ${prid}`)
      return prid
    } else {
      Logger.warn(`ensurePridFetched: PRID fetch failed for pcrId=${pcrDoc.pcrId} — will retry on next open`)
    }
  } catch (err) {
    Logger.warn(`ensurePridFetched: PRID fetch threw for pcrId=${pcrDoc.pcrId} — will retry on next open: ${err}`)
  }
  return null
}
